<template>
  <div class="animated fadeIn">
    <b-row>
      <b-col sm="6" lg="6">
        <b-card header="Client Form">
          <el-form
            :model="customerForm"
            :rules="rulesProfile"
            ref="editCustomerForm"
            label-width="160px"
            class="demo-settingsForm"
          >
            <h4>General</h4>
            <hr />
            <el-form-item label="Company:" prop="company">
              <el-input v-model="customerForm.company"></el-input>
            </el-form-item>

            <el-form-item label="First Name:" prop="firstName">
              <el-input v-model="customerForm.firstName"></el-input>
            </el-form-item>

            <el-form-item label="Last Name:" prop="lastName">
              <el-input v-model="customerForm.lastName"></el-input>
            </el-form-item>

            <el-form-item label="Email Address:" prop="email">
              <el-input v-model="customerForm.email"></el-input>
            </el-form-item>

            <el-form-item label="Phone Number:" prop="phone">
              <el-input v-model="customerForm.phone"></el-input>
            </el-form-item>

            <h4>Physical Address</h4>
            <hr />
            <el-form-item label="Street Address:" prop="address1">
              <el-input v-model="customerForm.address1"></el-input>
            </el-form-item>

            <el-form-item label="Street 2nd Line:" prop="address2">
              <el-input v-model="customerForm.address2"></el-input>
            </el-form-item>
            <el-form-item label="City:" prop="city">
              <el-input v-model="customerForm.city"></el-input>
            </el-form-item>
            <el-form-item label="State:" prop="state">
              <el-input v-model="customerForm.state"></el-input>
            </el-form-item>
            <el-form-item label="Zip:" prop="zip">
              <el-input v-model="customerForm.zip"></el-input>
            </el-form-item>

            <el-form-item>
              <el-button @click="updateCustomer()">Save</el-button>
              <el-button type="primary" @click="updateCustomer(true)">Save &amp; Close</el-button>
            </el-form-item>
          </el-form>
        </b-card>
      </b-col>
      <b-col sm="6" lg="6">
        <b-card :header="this.existingAuth?'Updating Client Admin Access':'Client Admin Access'">
          <el-form
            v-if="editAuthForm"
            :model="customerAuth"
            :rules="rulesAuth"
            ref="newCustomerForm"
            label-width="160px"
            class="demo-settingsForm"
            autocomplete="off"
          >
            <p
              v-if="!this.existingAuth && disableNewUsernameForm"
              style="color:red; text-align:center;"
            >This username is already used.</p>
            <el-form-item v-if="!this.existingAuth" label="Username:">
              <el-input autocomplete="false" name="new-username" v-model="customerAuth.username"></el-input>
            </el-form-item>

            <el-form-item label>
              <p
                style="line-height:16px; color: gray;"
              >Using the two forms below, type in the new password twice. We require you to enter it twice, ensuring the password you are setting is correct.</p>
            </el-form-item>

            <el-form-item label="New Password:">
              <el-input
                autocomplete="false"
                name="new-password-1"
                type="password"
                v-model="customerAuth.password1"
              ></el-input>
            </el-form-item>

            <el-form-item label="Repeat Password:" prop="passwordRepeat">
              <el-input
                autocomplete="false"
                name="new-password-2"
                type="password"
                v-model="customerAuth.password2"
              ></el-input>
            </el-form-item>

            <el-form-item v-if="!this.existingAuth">
              <el-button
                type="primary"
                @click="createAuthentication()"
                :disabled="disableNewUsernameForm"
              >Save</el-button>
            </el-form-item>
            <el-form-item v-if="this.existingAuth">
              <el-button type="primary" @click="updateAuthentication()">Update</el-button>
            </el-form-item>
          </el-form>
          <div v-if="!editAuthForm">
            <el-form label-width="160px" autocomplete="off">
              <el-form-item label="Username:" size="mini">
                <div>
                  <b>{{customerAuth.username}}</b>
                </div>
              </el-form-item>
              <el-form-item label>
                <div>
                  <el-button type="primary" @click="editAuth()">Change Password</el-button>
                </div>
              </el-form-item>
            </el-form>
          </div>
        </b-card>
      </b-col>
    </b-row>
  </div>
</template>
<script>
import axios from '../../shared/axios';
import { mapGetters, mapActions } from 'vuex';

export default {
  data() {
    const validatePass = (rule, value, callback) => {
      if (this.customerAuth.password2 === '') {
        callback(new Error('Please input the password again'));
      } else if (this.customerAuth.password1 !== this.customerAuth.password2) {
        callback(new Error("Two inputs don't match!"));
      } else {
        callback();
      }
    };
    return {
      clientId: undefined,
      existingAuth: false,
      editAuthForm: false,
      disableNewUsernameForm: false,
      customerForm: {
        company: undefined,
        firstName: undefined,
        lastName: undefined,
        email: undefined,
        address1: undefined,
        address2: undefined,
        city: undefined,
        state: undefined,
        zip: undefined
      },
      rulesProfile: {
        company: [
          {
            required: true,
            message: 'Please input a company name',
            trigger: 'blur'
          }
        ],
        firstName: [
          {
            required: true,
            message: "Please input the contact's first name",
            trigger: 'blur'
          }
        ],
        lastName: [
          {
            required: true,
            message: "Please input the contact's last name",
            trigger: 'blur'
          }
        ],
        email: [
          {
            required: true,
            message: 'Please input email address',
            trigger: 'blur'
          }
        ],
        phone: [
          {
            required: true,
            message: 'Please input a phone number',
            trigger: 'blur'
          }
        ]
      },
      customerAuth: {
        username: undefined,
        password1: undefined,
        password2: undefined
      },
      rulesAuth: {
        username: [
          {
            required: true,
            message: 'Please input a username',
            trigger: 'blur'
          }
        ],
        password: [
          {
            required: true,
            message: 'Please input a password',
            trigger: 'blur'
          }
        ],
        passwordRepeat: [{ validator: validatePass, trigger: 'blur' }]
      }
    };
  },
  computed: {
    ...mapGetters('auth', [
      'getCompanyName',
      'getDistributorName',
      'isDistributor',
      'isEmulated',
      'is360Enabled'
    ]),
  },
  created() {
    const clientId = this.$route.params.id;
    this.clientId = clientId;
    axios.get('clients/' + clientId).then(r => {
      this.customerForm = {
        company: r.data.company,
        firstName: r.data.first_name,
        lastName: r.data.last_name,
        phone: r.data.main_phone,
        email: r.data.e_mail_1,
        address1: r.data.address,
        address2: undefined,
        city: r.data.city,
        state: r.data.state,
        zip: r.data.zip
      };
    });
    axios
      .get('client/authentication/' + clientId)
      .then(r => {
        // console.log(r);
        if (r.data.auth.length > 0) {
          this.existingAuth = true;
          this.editAuthForm = false;
          this.customerAuth.username = r.data.auth[0].username;
          // this.customerAuth.password1 = r.data.auth[0].password;
        } else {
          this.editAuthForm = true;
        }
      })
      .catch(e => {
        console.log(e);
      });
  },
  watch: {
    'customerAuth.username': {
      handler: function(after, before) {
        // console.log(after);
        this.checkAuthentication();
      },
      deep: true
    }
  },
  methods: {
    editAuth() {
      this.editAuthForm = !this.editAuthForm;
    },
    updateCustomer(close = false) {
      // black
      axios
        .put('client/update/' + this.clientId + '/', this.customerForm)
        .then(r => {
          this.$message({
            message: 'Updated client',
            type: 'success'
          });
          if (close) {
            this.$router.push('/client/list');
          }
        })
        .catch(e => {
          this.$message({
            message: 'Updated client',
            type: 'error'
          });
        });
    },
    checkAuthentication() {
      axios
        .get('client/authentication/check/' + this.customerAuth.username)
        .then(r => {
          // console.log(r.data);
          if (r.data.exists) {
            this.disableNewUsernameForm = true;
          } else {
            this.disableNewUsernameForm = false;
          }
        });
    },
    updateAuthentication() {
      if (this.customerAuth.password1 !== this.customerAuth.password2) {
        this.$message({
          message: "Passwords don't match",
          type: 'error'
        });
        return;
      }
      axios
        .put('client/authentication/' + this.clientId + '/', this.customerAuth)
        .then(r => {
          console.log(r.data);
          this.$message({
            message: 'Updated password',
            type: 'success'
          });
          this.editAuthForm = false;
        })
        .catch(e => {
          this.$message({
            message: 'Error updating password',
            type: 'error'
          });
        });
    },
    createAuthentication() {
      console.log('create');
      axios
        .post('client/authentication/' + this.clientId + '/', this.customerAuth)
        .then(r => {
          console.log(r.data);
          this.$message({
            message: 'Created Username and Password',
            type: 'success'
          });
          this.editAuthForm = false;
        })
        .catch(e => {
          console.log(e);
          this.$message({
            message: "Couldn't create Username and Password",
            type: 'error'
          });
        });
    }
  }
};
</script>
